module.exports = __webpack_public_path__ + "static/media/theme-logo.3f131df1.svg";